import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="space-y-6 max-w-md">
        <div className="flex justify-center">
          <div className="relative">
            <div className="absolute -inset-4 rounded-full bg-primary/10 blur-xl"></div>
            <h1 className="relative text-9xl font-extrabold tracking-tighter text-primary/80">
              404
            </h1>
          </div>
        </div>

        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
            {t("common.states.notFoundTitle", "Page not found")}
          </h2>
          <p className="text-muted-foreground text-lg">
            {t(
              "common.states.notFoundDescription",
              "Sorry, we couldn't find the page you're looking for. It might have been moved or doesn't exist.",
            )}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("common.states.goBack", "Go Back")}
          </Button>

          <Button
            onClick={() => navigate("/")}
            className="gap-2"
          >
            <Home className="h-4 w-4" />
            {t("common.states.backToHome", "Back to Home")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
